import React, {useEffect, useState} from "react";
import AddDialogFlashCardComponent from "./AddDialogFlashCardComponent";
import firebase from "firebase";
import _ from "lodash";
import {Button, Grid, Message, Progress} from "semantic-ui-react";
import {storage} from "../../../firebase";
import DialogFlashCardAdder from "./DialogFlashCardAdder";
import {CheckEmptyDialogFlashCardField} from "../../../helpers/CheckEmptyFields/CheckEmptyDialogFlashCardField";
import {DownloadJSONFile} from "../../../helpers/DownloadJSONFile";
import axios from "axios";
import TranslationFlashCardAdder from "../TranslationFlashCards/TranslationFlashCardAdder";

function AddDialogFlashCardAssignment(
    {
        classLevel,
        handleClassLevel,
        editAssignment,
        assignment,
        setEditAssignmentLoading,
        setEditAssignmentProgress,
        actionChoice,
        databaseChoice
    }
) {

    const [numberOfForms, setNumberOfForms] = useState(0);
    const [forms, setForms] = useState(null);
    const [dialogFlashCardAssignments, setDialogFlashCardAssignments] = useState([]);
    const [error, setError] = useState('');
    const [fileNames, setFileNames] = useState([]);
    const [success, setSuccess] = useState(false);
    const [questionAudio, setQuestionAudio] = useState([]);
    const [responseAudio, setResponseAudio] = useState([]);
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [progressText, setProgressText] = useState('');
    const [buildAssignment, setBuildAssignment] = useState(false);
    const [dataSet, setDataSet] = useState(false);
    const [assignmentName, setAssignmentName] = useState('')


    useEffect(() => {

        async function fetchData() {
            setBuildAssignment(false);
            setSuccess(false);
            setLoading(false);
            setNumberOfForms(0);
            setDialogFlashCardAssignments([]);
            setQuestionAudio([]);
            setResponseAudio([]);
            let tmpFileNames = [];
            firebase.storage().ref().child('assignments/Samoan10' + classLevel + '/dialogFCAssignments').listAll()
                .then((data) => {
                    data.items.forEach((folderRef) => {

                        tmpFileNames.push(folderRef.location.path_.split('/')[3])
                    })
                }).catch(e => console.log(e));


            setFileNames(tmpFileNames)
        }

        async function fetchAssignmentData() {
            setBuildAssignment(true);
            setSuccess(false);
            setLoading(false);
            setEditAssignmentLoading(true);
            const fetchedAssignment = await firebase.storage().ref().child('assignments/Samoan10' + classLevel + '/dialogFCAssignments/' + assignment)
            await fetchedAssignment.getDownloadURL()
                .then((url) => axios.get(url))
                .then(res => {
                    async function setData(data) {
                        await setDialogFlashCardAssignments(data);
                    }

                    setEditAssignmentProgress(50)
                    setData(res.data);
                    buildEditAssignments(res.data);
                    setAssignmentName(assignment)
                });
        }

        if (editAssignment) {
            fetchAssignmentData().then(() => {
                setEditAssignmentLoading(false);
                setEditAssignmentProgress(0)
            })
        } else {

            fetchData().then(() => console.log('ready')).catch(e => console.log(e))
        }
    }, [classLevel, editAssignment, actionChoice, databaseChoice]);


    const handleChange = (event) => {
        if (event.target.value < 0) {
            event.target.value = 0
        }
        setError('');
        setNumberOfForms(event.target.value);
        let tmpDialogFlashCardAssignments = dialogFlashCardAssignments;

        for (let i = 0; i < event.target.value; i++) {
            tmpDialogFlashCardAssignments.push({
                question: [''],
                response: [''],
                englishQuestion: [''],
                englishResponse: [''],
                questionAudio: [''],
                responseAudio: ['']
            });
        }
        setDialogFlashCardAssignments(tmpDialogFlashCardAssignments);
        setBuildAssignment(false)
    };

    const buildEditAssignments = (data) => {
        setNumberOfForms(data.length);
        setBuildAssignment(true)
    };

    const handleAddQuestionField = (index) => {
        let tmpDialogFlashCardAssignments = dialogFlashCardAssignments;
        tmpDialogFlashCardAssignments[index].question.push('');
        tmpDialogFlashCardAssignments[index].englishQuestion.push('');
        tmpDialogFlashCardAssignments[index].questionAudio.push('');
        setDialogFlashCardAssignments(tmpDialogFlashCardAssignments)
    };

    const handleAddResponseField = (index) => {
        let tmpDialogFlashCardAssignments = dialogFlashCardAssignments;
        tmpDialogFlashCardAssignments[index].response.push('');
        tmpDialogFlashCardAssignments[index].englishResponse.push('');
        tmpDialogFlashCardAssignments[index].responseAudio.push('');
        setDialogFlashCardAssignments(tmpDialogFlashCardAssignments)
    };
    const handleSubtractQuestionField = (index) => {
        let tmpDialogFlashCardAssignments = dialogFlashCardAssignments;
        tmpDialogFlashCardAssignments[index].question.splice(-1, 1);
        tmpDialogFlashCardAssignments[index].englishQuestion.splice(-1, 1);
        tmpDialogFlashCardAssignments[index].questionAudio.splice(-1, 1);
        setDialogFlashCardAssignments(tmpDialogFlashCardAssignments)
    }
    const handleSubtractResponseField = (index) => {
        let tmpDialogFlashCardAssignments = dialogFlashCardAssignments;
        tmpDialogFlashCardAssignments[index].response.splice(-1, 1);
        tmpDialogFlashCardAssignments[index].englishResponse.splice(-1, 1);
        tmpDialogFlashCardAssignments[index].responseAudio.splice(-1, 1);
        setDialogFlashCardAssignments(tmpDialogFlashCardAssignments)
    }

    const handleSetDialogFlashCardData = (event, index) => {
        setError('');
        let value = event.target.value;
        let tmpDialogFlashCardAssignmentData = dialogFlashCardAssignments;
        if (event.target.name === "questionAudio" || event.target.name === "responseAudio") {
            value = "dialogFC_" + value.split('\\')[2]
        }
        if (event.target.name === "questionAudio") {
            let tmpQuestionAudio = new File([event.target.files[0]], 'dialogFC_' + event.target.files[0].name);
            setQuestionAudio(prevState => [...prevState, tmpQuestionAudio])
        }
        if (event.target.name === "responseAudio") {
            let tmpResponseAudio = new File([event.target.files[0]], 'dialogFC_' + event.target.files[0].name);
            setResponseAudio(prevState => [...prevState, tmpResponseAudio])
        }
        tmpDialogFlashCardAssignmentData[event.target.id][event.target.name][index] = value;
        setDialogFlashCardAssignments(prevState => [...tmpDialogFlashCardAssignmentData])
    };

    const createForms = () => {
        if (numberOfForms <= 0) {
            setError('The number of flash cards need to be greater than 0')
        } else {
            if (dialogFlashCardAssignments.length > numberOfForms) {
                let numberToRemove = numberOfForms - dialogFlashCardAssignments.length;
                dialogFlashCardAssignments.splice(numberToRemove)
            }
            setBuildAssignment(true);
        }


    };

    const uploadAssignment = () => {
        setError('');
        const tmpError = CheckEmptyDialogFlashCardField(dialogFlashCardAssignments);
        if (tmpError) {
            setError(tmpError)
        } else if (numberOfForms == 0) {
            setError('You cannot upload an empty assignment')
        } else {
            setLoading(true)
            for (let i = 0; i < questionAudio.length; i++) {
                const uploadTask = storage.ref(`sounds/${questionAudio[i].name}`).put(questionAudio[i]);
                uploadTask.on(
                    "state_changed",
                    () => {
                    },
                    error => {
                        console.log(error)
                    },
                    () => {
                        storage
                            .ref("sounds")
                            .child(questionAudio[i].name)
                            .getDownloadURL()
                            .then(() => {
                                    setProgress(prevState => prevState + Math.round(50 / questionAudio.length))
                                    setProgressText('Uploading speaker A audio files')
                                }
                            ).catch(e => console.log(e))
                    }
                )

            }
            for (let i = 0; i < responseAudio.length; i++) {
                const uploadTask = storage.ref(`sounds/${responseAudio[i].name}`).put(responseAudio[i]);
                uploadTask.on(
                    "state_changed",
                    () => {
                    },
                    error => {
                        console.log(error)
                    },
                    () => {
                        storage
                            .ref("sounds")
                            .child(responseAudio[i].name)
                            .getDownloadURL()
                            .then(() => {
                                    setProgress(prevState => prevState + Math.round(50 / responseAudio.length))
                                    setProgressText('Uploading speaker B audio files')
                                }
                            ).catch(e => console.log(e))
                    }
                )

            }

            const JSONobj = JSON.stringify(dialogFlashCardAssignments);
            const blobObj = new Blob([JSONobj], {type: "application/json"});

            if (editAssignment) {
                DownloadJSONFile(dialogFlashCardAssignments, assignmentName).then(r => console.log('ready'))
                const uploadTask = storage.ref(`assignments/Samoan10` + classLevel + `/dialogFCAssignments/assignment/` + assignmentName).put(blobObj);
                uploadTask.on(
                    "state_changed",
                    () => {
                    },
                    error => {
                        console.log(error)
                    },
                    () => {
                        storage
                            .ref("assignments/Samoan10" + classLevel + "/dialogFCAssignments")
                            .child(assignmentName)
                            .getDownloadURL()
                            .then(url => {
                                    setLoading(false);
                                    setSuccess(true)
                                }
                            )
                            .catch(e => console.log(e));
                    }
                )
            } else {
                DownloadJSONFile(dialogFlashCardAssignments, fileNames).then(r => console.log('ready'))
                const uploadTask = storage.ref(`assignments/Samoan10` + classLevel + `/dialogFCAssignments/assignment${fileNames.length + 1}.json`).put(blobObj);
                uploadTask.on(
                    "state_changed",
                    () => {
                    },
                    error => {
                        console.log(error)
                    },
                    () => {
                        storage
                            .ref("assignments/Samoan10" + classLevel + "/dialogFCAssignments")
                            .child(`assignment${fileNames.length + 1}.json`)
                            .getDownloadURL()
                            .then(url => {
                                    setLoading(false);
                                    setSuccess(true)
                                }
                            )
                            .catch(e => console.log(e));
                    }
                )
            }
        }
    };

    const handleClearData = () => {
        setNumberOfForms(0);
        setDialogFlashCardAssignments([]);
        setError('');
        setSuccess(false);
        setQuestionAudio([]);
        setResponseAudio([]);
        setLoading(false);
        setProgress(0);
        setProgressText('')
        setBuildAssignment(false);
        setDataSet(false);
        let tmpFileNames = [];
        firebase.storage().ref().child('assignments/Samoan10' + classLevel + '/dialogFCAssignments').listAll()
            .then((data) => {
                data.items.forEach((folderRef) => {

                    tmpFileNames.push(folderRef.location.path_.split('/')[3])
                })
            }).catch(e => console.log(e));


        setFileNames(tmpFileNames)
    };

    return (
        <>
            <AddDialogFlashCardComponent
                handleChange={handleChange}
                forms={forms}
                createForms={createForms}
                uploadAssignment={uploadAssignment}
                error={error}
                success={success}
                loading={loading}
                progress={progress}
                buildAssignment={buildAssignment}
                classLevel={classLevel}
                handleClassLevel={handleClassLevel}
                handleClearData={handleClearData}
                editAssignment={editAssignment}
                assignment={assignment}
            />
            <Grid centered={true}>
                {
                    buildAssignment ? _.times(numberOfForms, (i) => (
                            <DialogFlashCardAdder
                                key={i}
                                questionNumber={i}
                                id={i}
                                value={dialogFlashCardAssignments[i]}
                                handleSetDialogFlashCardData={handleSetDialogFlashCardData}
                                handleAddQuestionField={handleAddQuestionField}
                                handleAddResponseField={handleAddResponseField}
                                handleSubtractResponseField={handleSubtractResponseField}
                                handleSubtractQuestionField={handleSubtractQuestionField}
                            />
                        ))
                        :
                        null
                }
                {
                    success ?
                        <Grid.Row>
                            <Message positive>
                                <Message.Header>Assignment has been uploaded to the Dialog Flash Cards
                                    page</Message.Header>
                            </Message>
                        </Grid.Row>
                        :
                        null
                }
                {
                    error ?
                        <Grid.Row>
                            <Message negative>
                                <Message.Header>{error}</Message.Header>
                            </Message>
                        </Grid.Row>
                        :
                        null
                }
                {
                    loading ?
                        <Grid.Row>
                            <Progress style={{width: 400}} indicating progress percent={progress}>
                                {progressText}
                            </Progress>
                        </Grid.Row>
                        :
                        success ?
                            <Grid.Row>
                                <br/>
                                <Button color='green' disabled={true} onClick={uploadAssignment}>Upload
                                    Assignment</Button>
                            </Grid.Row>
                            :
                            buildAssignment ?
                                <Grid.Row>
                                    <br/>
                                    <Button color='green' onClick={uploadAssignment}>Upload Assignment</Button>
                                </Grid.Row>
                                :
                                <Grid.Row>
                                    <br/>
                                    <Button color='green' disabled onClick={uploadAssignment}>Upload Assignment</Button>
                                </Grid.Row>
                }
            </Grid>
            <br/>
            <br/>
            <br/>
        </>
    )
}

export default AddDialogFlashCardAssignment
